<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item label="公司名称">
							<el-input v-model="searchCondition.CompanyName" placeholder="请输入公司名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="企业类型">
							<el-select v-model="searchCondition.CompanyType" placeholder="请选择企业类型" clearable>
								<el-option label="人力资源公司" value="1"></el-option>
								<el-option label="用工公司" value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="负责人姓名">
							<el-input v-model="searchCondition.ContactsName" placeholder="请输入负责人姓名" clearable></el-input>
						</el-form-item>
						<el-form-item label="负责人电话">
							<el-input v-model="searchCondition.ContactsMobile" placeholder="请输入负责人电话" clearable></el-input>
						</el-form-item>
						<el-form-item label="从事行业">
							<el-cascader
								v-model="searchCondition.Type"
								:options="industryList"
								:props="industryProps"
								placeholder="请选择从事行业"
								clearable
								filterable
							></el-cascader>
						</el-form-item>
						<el-form-item label="发票类型">
							<el-select v-model="searchCondition.InvoiceType" placeholder="请选择发票类型" clearable>
								<el-option label="专用发票" value="1"></el-option>
								<el-option label="普通发票" value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="所需通道">
							<el-select v-model="searchCondition.Channels" placeholder="请选择所需通道" clearable>
								<el-option label="支付宝" value="ALIPAY"></el-option>
								<el-option label="微信" value="WECHAT"></el-option>
								<el-option label="银行卡" value="BANK"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="审核状态">
							<el-select v-model="searchCondition.Status" placeholder="请选择审核状态" clearable>
								<el-option label="待审核" value="0"></el-option>
								<el-option label="审核通过" value="1"></el-option>
								<el-option label="审核拒绝" value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="时间">
							<DatePicker @dataSearch="dataSearch" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
					<el-table-column label="业务介绍" width="180" align="center">
						<template slot-scope="scope">
							<el-tooltip
								v-if="scope.row.remark"
								effect="dark"
								:content="scope.row.remark"
								placement="top"
								popper-class="remark-tooltip"
							>
								<div class="remark-ellipsis">{{ scope.row.remark }}</div>
							</el-tooltip>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column label="审核状态" width="100" align="center">
						<template slot-scope="scope">
							{{ statusMap[scope.row.status] || '-' }}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="200" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button v-if="scope.row.status == 0" type="text" size="mini" @click="handleAudit(scope.row)">去审核</el-button>
							<el-button type="text" size="mini" @click="createCompany(scope.row)">编辑公司</el-button>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>

		<el-dialog title="审核" :visible.sync="auditVisible" width="35%" center @close="auditCancel">
			<el-radio-group v-model="auditStatus">
				<el-radio :label="1">审核通过</el-radio>
				<el-radio :label="2">审核拒绝</el-radio>
			</el-radio-group>
			<el-input
				v-show="auditStatus == 2"
				v-model="auditRemark"
				class="audit-remark"
				type="textarea"
				:rows="4"
				placeholder="请输入拒绝原因..."
			></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="auditCancel">取 消</el-button>
				<el-button type="primary" :loading="auditLoading" @click="auditSure">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'

const channelMap = {
	ALIPAY: '支付宝',
	WECHAT: '微信',
	BANK: '银行卡'
}

export default {
	name: 'CreateAccountRecord',
	components: {
		PageHeaderLayout,
		ApeTable,
		DatePicker
	},
	data() {
		return {
			searchCondition: {},
			industryList: [],
			industryProps: {
				value: 'value',
				label: 'label',
				children: 'children',
				checkStrictly: true
			},
			loadingStaus: true,
			auditVisible: false,
			auditLoading: false,
			auditStatus: 1,
			auditRemark: '',
			currentRowData: {},
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			statusMap: {
				0: '待审核',
				1: '审核通过',
				2: '审核拒绝',
				3: '已开户'
			},
			columns: [
				{ title: '公司名称', value: 'company_name', header_align: 'center', align: 'center', width: 180 },
				{ title: '企业类型', value: 'company_type_text', header_align: 'center', align: 'center', width: 110 },
				{ title: '负责人姓名', value: 'contacts_name', header_align: 'center', align: 'center', width: 120 },
				{ title: '负责人电话', value: 'contacts_mobile', header_align: 'center', align: 'center', width: 140 },
				{ title: '从事行业', value: 'type_name', header_align: 'center', align: 'center', width: 140 },
				{ title: '发票类型', value: 'invoice_type_text', header_align: 'center', align: 'center', width: 100 },
				{ title: '所需通道', value: 'channels_text', header_align: 'center', align: 'center', width: 160 },
				{ title: '自由职业者数量', value: 'person_num', header_align: 'center', align: 'center', width: 140 },
				{ title: '结算量(万/月)', value: 'money', header_align: 'center', align: 'center', width: 130 }
			]
		}
	},
	methods: {
		dataSearch(value) {
			this.searchCondition.time_value = value
		},
		searchButton() {
			this.initList('search')
		},
		switchPaging() {
			this.initList()
		},
		createCompany(row) {
			if (!row.company_id) {
				this.$message.error('缺少公司ID')
				return
			}
			this.$router.push({
				name: 'createAccountRecordEdit',
				params: {
					company_id: row.company_id
				},
				query: {
					category: 'ordinary',
					id: row.company_id,
					name: row.company_name
				}
			})
		},
		handleAudit(row) {
			this.auditVisible = true
			this.currentRowData = row
			this.auditStatus = 1
			this.auditRemark = ''
		},
		auditCancel() {
			this.auditVisible = false
			this.auditStatus = 1
			this.auditRemark = ''
			this.currentRowData = {}
		},
		async auditSure() {
			if (this.auditStatus == 2 && !this.auditRemark) {
				this.$message.error('请输入拒绝原因')
				return
			}
			if (!this.$api.applyAccountRecord) {
				this.$message.error('请先提供企业开户审核接口')
				return
			}
			this.auditLoading = true
			try {
				const params = {
					Status: this.auditStatus
				}
				if (this.auditStatus == 2) {
					params.Message = this.auditRemark
				}
				await this.$api.applyAccountRecord(this.currentRowData.id, params)
				this.$message.success('提交成功')
				this.auditCancel()
				this.initList()
			} catch (e) {
				this.$message.error(e.message || '提交失败')
			}
			this.auditLoading = false
		},
		getSearchParams() {
			const params = { ...this.searchCondition }
			if (params.time_value) {
				params.start_date = params.time_value[0]
				params.end_date = params.time_value[1]
				delete params.time_value
			} else {
				params.start_date = ''
				params.end_date = ''
			}
			if (params.Type && params.Type.length) {
				params.Type = params.Type[params.Type.length - 1]
			}
			return params
		},
		formatList(list) {
			return list.map(item => {
				const channels = item.channels ? String(item.channels).split(',') : []
				return {
					...item,
					company_type_text: item.company_type == 1 ? '人资公司' : item.company_type == 2 ? '用工公司' : '-',
					invoice_type_text: item.invoice_type == 1 ? '专票' : item.invoice_type == 2 ? '普票' : '-',
					channels_text: channels.map(channel => channelMap[channel] || channel).join(',')
				}
			})
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
			if (type === 'search') {
				pagingInfo.current_page = 1
			}
			if (!this.$api.getAccountRecordList) {
				this.loadingStaus = false
				return
			}
			try {
				const params = {
					type: 1,
					...pagingInfo,
					...this.getSearchParams()
				}
				const res = await this.$api.getAccountRecordList(params)
				const list = res.data || res.list || []
				const pages = res.pages || { total: 0, offset: 0 }
				this.tableData = this.formatList(list)
				this.pagingData.total = pages.total || 0
				this.pagingData.offset = pages.offset || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取列表失败')
			}
			this.loadingStaus = false
		},
		normalizeIndustryTree(list) {
			return (list || []).map(item => {
				const children = this.normalizeIndustryTree(item.children)
				const node = {
					label: item.label_category_name || item.label || item.name,
					value: item.id
				}
				if (children.length) {
					node.children = children
				}
				return node
			})
		},
		async getIndustryList() {
			if (!this.$api.getIndustryTypeList) {
				return
			}
			try {
				const res = await this.$api.getIndustryTypeList()
				this.industryList = this.normalizeIndustryTree(res)
			} catch (e) {
				this.industryList = []
			}
		}
	},
	mounted() {
		this.getIndustryList()
		this.initList()
	}
}
</script>

<style lang="scss" scoped>
.table-search {
	margin-bottom: 16px;
}
.audit-remark {
	margin-top: 24px;
}
.remark-ellipsis {
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	line-clamp: 2;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	line-height: 20px;
	text-align: left;
}
</style>

<style lang="scss">
.remark-tooltip {
	max-width: 320px;
	line-height: 20px;
	white-space: normal;
	word-break: break-all;
}
</style>
